import { Link } from "react-router-dom";
import { useBranding } from "@/context/AuthContext";
import { BrandLogo } from "@/components/BrandLogo";

export const Section = ({ title, children }) => (
  <section className="space-y-2">
    <h2 className="text-base md:text-lg font-bold text-slate-900">{title}</h2>
    <div className="text-sm text-slate-600 leading-relaxed space-y-2">{children}</div>
  </section>
);

export const LegalLayout = ({ title, updated, children, testid }) => {
  const { data: b } = useBranding();
  return (
    <div className="min-h-[100dvh] bg-[#F8FAFC] overflow-y-auto" data-testid={testid}>
      <header className="bg-[#0F172A] text-white">
        <div className="max-w-3xl mx-auto px-5 py-5 flex items-center gap-3">
          <BrandLogo size={34} />
          <span className="font-bold">{b?.company_name}</span>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-10">
        <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">{title}</h1>
        <p className="text-xs text-slate-400 mt-2 mb-8">Ultimo aggiornamento: {updated}</p>
        <div className="bg-white border border-slate-200 rounded-xl p-6 md:p-8 space-y-7">{children(b || {})}</div>
        <nav className="mt-8 flex flex-wrap gap-4 text-xs text-slate-500">
          <Link to="/privacy" className="hover:text-slate-900" data-testid="legal-link-privacy">Privacy policy</Link>
          <Link to="/eliminazione-dati" className="hover:text-slate-900" data-testid="legal-link-deletion">Eliminazione dati</Link>
          <span>© {new Date().getFullYear()} {b?.company_name}</span>
        </nav>
      </main>
    </div>
  );
};
